var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d4bsa",
    d: "M1089.929 5111.09h11.376l-3.577-3.807a1.021 1.021 0 0 1-.27-.702c0-.264.095-.515.27-.7l.557-.592a.894.894 0 0 1 1.314 0l6.13 6.51c.176.187.272.435.27.7.002.266-.094.515-.27.701l-6.13 6.512a.897.897 0 0 1-1.314 0l-.557-.59a1.012 1.012 0 0 1-.27-.7.98.98 0 0 1 .27-.684l3.617-3.828h-11.402c-.512 0-.943-.47-.943-1.014v-.836c0-.544.443-.976.956-.976"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1089 -5105)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#d4bsa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightLight);
export default __webpack_public_path__ + "static/media/icon-arrow-right-light.7f07d5406d4da24292a7172186a4d0ad.svg";
export { ForwardRef as ReactComponent };